import * as yup from "yup";

export const rowSchema = yup.object().shape({
  package_tracking_number: yup.string().trim().required("package tracking number is required"),
});
